import { ServiceMaker, methods, services } from '@/services';
import { NIPIGE_RBAC } from '@/config/index'
import Axios from "axios";

export const listRoles = () => ServiceMaker('/role/list', methods.GET, services.rbac);

export const updateRole = (id, data) => ServiceMaker(`/role/${id}`, methods.PUT, services.rbac, data);

export const deleteRole = (id) => ServiceMaker(`/role/${id}`, methods.DELETE, services.rbac);

export const createRole = (data) => ServiceMaker('/role', methods.POST, services.rbac, data);

export const listPermissions = () => ServiceMaker('/permission', methods.GET, services.rbac);

export const createPermission = (data) => ServiceMaker('/permission', methods.POST, services.rbac, data);

export const editPermission = (id, data) => ServiceMaker(`/permission/${id}`, methods.PUT, services.rbac, data)

export const deletePermission = (id) => ServiceMaker(`/permission/${id}`, methods.DELETE, services.rbac);

export const getPermissionsByRole = (id) => ServiceMaker(`/role-permission/${id}`, methods.GET, services.rbac);

export const addPermissionToRole = (role: string, permission: string) => ServiceMaker('/role-permission', methods.POST, services.rbac, {
    permission,
    role,
});

export const deletePermissionToRole = (Id) => ServiceMaker(`/role-permission/${Id}`, methods.DELETE, services.rbac);

export const fetchPermissionByUser = async (payload) => {
    try {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${payload.token}`
        }
        let dataObj = {
            roles: payload.data
        }
        let result = await Axios.post(`${NIPIGE_RBAC}/role-permission/permissions-by-roles`, dataObj, {
            headers: headers
        });
        return result.data
    } catch (error) {
        throw error
    }

}

const authUrlsByRole = {
    'Admin': '/users/admin/login',
    'Tenant': '/users/tenant/login',
    'Partner': '/users/partner/login'
}

export const login = (role, data) => ServiceMaker(authUrlsByRole[role], methods.POST, services.nipige, data);

